<template lang="pug">
.input-location
  .d-flex.flex-row.align-items-center
    //- location name
    span.item-name.mr-2 場所名
    b-form-input.location-name.mr-4(
      v-model="_value.name"
      :name="name + '-name'"
      placeholder="場所名"
      v-validate="{ required: true, max: 10 }"
      data-vv-as="場所名"
      :maxlength="10"
      @change="onChange"
    )
    //- concurrent number limit
    span.item-name.mr-2 同時予約可能数
    .concurrent-number-limit.mr-4
      b-form-select(
        v-model="_value.concurrentNumberLimit"
        :name="name + '-number'"
        :options="_concurrentNumberLimitOptions"
        v-validate="{ required: true }"
        data-vv-as="同時予約可能数"
        @change="onChange"
      )
    //- delete button
    button.trash-btn.btn(:class="{ 'disable': _disableDeleteButton }" :disabled="_disableDeleteButton" @click="onDelete")
      .trash-icon

  .error-messages(v-for="error in errors.collect(name + '-name')")
    label.error-message {{ error }}
    br
  .error-messages(v-for="error in errors.collect(name + '-number')")
    label.error-message {{ error }}
    br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { ConcurrentNumberLimit, LocationOption } from "@/commons/services/ReservationSettings";

@Component
export default class InputLocation extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: LocationOption;

  @Prop({ required: true })
  name!: string;

  get _concurrentNumberLimitOptions(): Array<{ value: ConcurrentNumberLimit; text: string }> {
    return [
      { value: ConcurrentNumberLimit.NO_LIMIT, text: "制限無し" },
      { value: ConcurrentNumberLimit.ONE, text: "1件" },
      { value: ConcurrentNumberLimit.TWO, text: "2件" },
      { value: ConcurrentNumberLimit.THREE, text: "3件" },
      { value: ConcurrentNumberLimit.FOUR, text: "4件" },
      { value: ConcurrentNumberLimit.FIVE, text: "5件" }
    ];
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): LocationOption {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: LocationOption) {
    this.$emit("input", newValue);
    return;
  }

  onChange(): void {
    console.log("this.value:", this.value);
    this.$emit("input", this.value);
    return;
  }

  onDelete(): void {
    this.$emit("onDelete");
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_mixin.scss";
@import "../../../styles/pc/_colors.scss";

.input-location {
  .item-name {
    font-weight: bold;
  }
  .location-name {
    max-width: 200px;
  }
  .concurrent-number-limit {
    width: 120px;
  }

  .trash-icon {
    @include svg-icon("../../../assets/trash.svg", $font-base-color, 24px, 24px);
  }
  .trash-btn {
    font-size: 16px !important;
    height: 32px !important;
    padding: 2px 5px !important;
  }
}
</style>
